import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const oldManModeSizes = [14, 16, 18, 20, 24, 28, 30, 32, 34]
export default new Vuex.Store({
  state: {
    accessibleMode: false,
    oldManMode: 0,
    websitInfo: {}
  },
  getters: {},
  mutations: {
    set_oldManMode(state, step = 2) {
      const value = state.oldManMode + step
      if (value > 8 || value < 0) {
        state.oldManMode = 0
        document.getElementById("app").classList.remove("old-man");
      } else if (value === 0) {

        document.getElementById("app").classList.remove("old-man");
      } else {
        state.oldManMode = value
        document.getElementById("app").classList.add("old-man");
      }
      oldManModeSizes.forEach((v) => {
        Vue.prototype.$setCssVar(`--font-size-${v}`, v + state.oldManMode + "px");
      });
    },
    set_AccessibleMode(state, data) {
      state.accessibleMode = data
    },
    set_websitInfo(state, data = {}) {
      state.websitInfo = data
    }
  },
  actions: {},
});